import React from "react"
import styled from "styled-components"
import { Link, useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const PictureGrid = ({ heading }) => {
  const data = useStaticQuery(graphql`
    query MyQuery {
      allDetailsJson {
        edges {
          node {
            id
            slug
            alt
            img {
              childImageSharp {
                gatsbyImageData(placeholder: DOMINANT_COLOR)
              }
            }
          }
        }
      }
    }
  `)

  function getDetails(data) {
    const detailsArray = []
    data.allDetailsJson.edges.forEach((item, index) => {
      const image = getImage(item.node.img)
      detailsArray.push(
        <ImageContainer key={index}>
          <ImageLink to={"/portfolio/" + item.node.slug}>
            <Image image={image} alt={item.node.alt} />
          </ImageLink>
        </ImageContainer>
      )
    })
    return detailsArray
  }

  return (
    <>
      <Wrapper>
        <Heading id={heading.toLowerCase()}>{heading}</Heading>
        <Container>
          {heading === "Wildlife"
            ? getDetails(data).slice(0, 9)
            : heading === "Landscape"
            ? getDetails(data).slice(9, 18)
            : heading === "Architecture"
            ? getDetails(data).slice(18, 27)
            : ""}
        </Container>
      </Wrapper>
    </>
  )
}

export default PictureGrid

const ImageContainer = styled.div``

const ImageLink = styled(Link)``

const Image = styled(GatsbyImage)`
  width: 80vw;
  max-width: 550px;
  margin: 0 2.5px 0 2.5px;

  @media screen and (min-width: 1000px) {
    width: auto;
    filter: brightness(85%);
    transition: 0.5s;
    cursor: pointer;

    &:hover {
      filter: brightness(100%);
    }
  }
`

const Heading = styled.h1`
  font-family: "julius sans one";
  font-size: clamp(1.5rem, 5vw, 2rem);
  margin-left: 2.5px;
  padding-top: 5.5vh;
`

const Wrapper = styled.div`
  @media screen and (min-width: 1000px) {
    width: fit-content;
    margin-left: 25vw;
  }

  @media screen and (min-width: 1400px) {
    margin-left: 350px;
  }
`

const Container = styled.div`
  overflow-x: auto;
  display: flex;

  @media screen and (min-width: 1000px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (min-width: 1400px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`
